export default __webpack_public_path__ + "static/media/store_white.47d9348a.svg";